import React from "react";
import Button from "../Common/Buttons/JobButton";

const ButtonSection = ({ onClick }) => {
  return (
    <div className="employers-cv-btn">
      <Button children="Upload Your CV" onClick={onClick} />
    </div>
  );
};

export default ButtonSection;
